import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Careers from "@/pages/Careers";
import CareerDetail from "@/pages/CareerDetail";
import Admin from "@/pages/Admin";
import Technology from "@/pages/Technology";
import MarketIntelligence from "@/pages/MarketIntelligence";
import QuantResearch from "@/pages/QuantResearch";
import AIML from "@/pages/AIML";
import NewsIntelligence from "@/pages/NewsIntelligence";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import EarlyAccess from "@/pages/EarlyAccess";
import PlatformAccess from "@/pages/PlatformAccess";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Disclaimer from "@/pages/Disclaimer";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Legacy /careers/job/:id → redirect to /careers/:slug */
function CareerByIdRedirect() {
  const { id } = useParams();
  const [target, setTarget] = useState(null);
  useEffect(() => {
    axios.get(`${API}/jobs/${id}`).then(r => setTarget(`/careers/${r.data.slug}`))
      .catch(() => setTarget("/careers"));
  }, [id]);
  if (!target) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  return <Navigate to={target} replace />;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/market-intelligence" element={<MarketIntelligence />} />
          <Route path="/quant-research" element={<QuantResearch />} />
          <Route path="/ai-ml" element={<AIML />} />
          <Route path="/news-intelligence" element={<NewsIntelligence />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<PlatformAccess />} />
          <Route path="/early-access" element={<EarlyAccess />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/job/:id" element={<CareerByIdRedirect />} />
          <Route path="/careers/:slug" element={<CareerDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}
